import { z } from 'zod';
import { AppearanceSchema } from '../commons';
export const BaseFieldDefinitionSchema = z.object({
    name: z.string(),
    label: z.string(),
    description: z.string().optional(),
    appearance: AppearanceSchema.optional(),
    validations: z
        .object({
        isRequired: z.boolean().optional()
    })
        .optional()
});
//# sourceMappingURL=base.js.map